// @ts-nocheck
import PropTypes from 'prop-types';
// material
import { Grid, Typography, Card,CardContent } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.any ,
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Grid
    container
    direction="row"
    justifyContent="space-evenly"
    alignItems="center"
  >
    <Card sx={{ width: 1 }}>
      <CardContent>
        <Typography gutterBottom align="center" variant="subtitle1">
          No record found!!!{' '}
        </Typography>
      </CardContent>
    </Card>
    </Grid>
  );
}
